import { Link, useLocation } from 'react-router-dom';
import { getHotMovies } from '@/lib/movieData';
import MovieCard from '@/components/feature/MovieCard';

export default function NotFound() {
  const location = useLocation();
  const recommend = getHotMovies(5);

  return (
    <div className="w-full">
      <section className="relative w-full px-4 md:px-8 py-20 md:py-28 bg-primary-950 overflow-hidden">
        <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-accent-500/10" />
        <div className="relative max-w-3xl">
          <p className="font-display text-7xl md:text-9xl font-extrabold text-primary-800 select-none leading-none">404</p>
          <h1 className="mt-4 font-display text-3xl md:text-4xl font-bold text-background-50">页面走丢了</h1>
          <p className="mt-4 text-sm md:text-base text-background-200/85 leading-relaxed">
            你要找的页面可能已被移动或不存在。别担心，我们为你准备了继续浏览的入口。
          </p>
          <p className="mt-2 text-xs text-background-200/50 font-mono break-all">{location.pathname}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/" className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-accent-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-home-4-line text-lg" />
              返回首页
            </Link>
            <Link to="/category/movie" className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-100/30 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-film-line text-lg" />
              去电影频道
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <h2 className="font-display text-xl md:text-2xl font-bold text-foreground-950">或许你想看看这些热门内容</h2>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {recommend.map((m) => <MovieCard key={m.id} movie={m} />)}
        </div>
      </section>
    </div>
  );
}